import React, { Suspense } from "react";
import ReactDOM from "react-dom";

import Common from "./Common";
import Cookie from "./Cookie";
import PottsalatMisc from "./pottsalat";
import DeliverySelector from "./DeliverySelector";
import ProductAddons from "./ProductAddons";
import Compensate from "./Compensate";
import LegacyCheckout from "./LegacyCheckout";

/** PAGES */
import HomePage from "./pages/Home";
import KonfiguratorIngredientApp from "./pages/Konfigurator/IngredientPage";
import CheckoutApp from "./pages/Checkout";
import ProductDetailsApp from "./pages/ProductDetails";
import CustomerAreaApp from "./pages/CustomerArea";
import ThankYouApp from "./pages/ThankYou";
import CategoryPageApp from "./pages/Category";
import ResetPasswordApp from "./pages/ResetPassword";

/** Global components */
import Header from "./components/Header";
import Chat from "./components/Chat";
import TopBar from "./components/Topbar";
import NewFooter from "./components/NewFooter";
import { CartProvider } from "./global/cartContext";
import FranchisePage from "./pages/Franchise";
import { initMetaPixelTracking } from "./Helpers/meta-pixel-util";
import { initGoogleTagTracking } from "./Helpers/google-tag-util";
import { generateUuid } from "./Helpers/util";
import TrackingContext from "./global/trackingContext";

const LazyWrapper = (props) => <Suspense fallback={<div></div>} {...props} />;

$(document).ready(() => {
    window.common = new Common();
    window.cookie = new Cookie();

    /**
     * Set anonymous user id
     */
    if (!window.cookie.get()?.pottsalatId) {
        window.cookie.update({
            ...window.cookie.get(),
            ...{ pottsalatId: generateUuid() },
        });
    }
    initMetaPixelTracking();
    initGoogleTagTracking();
    window.initMetaPixelTracking = initMetaPixelTracking;
    window.initGoogleTagTracking = initGoogleTagTracking;

    /**
     * Send view page request with page name data.
     */
    //const pageView = viewPage(document.title);

    /**
     * Cart compensate box
     */
    if (document.getElementById("cart-compensate-box")) {
        window.compensate = new Compensate();
    }

    /**
     * Pottsalat misc
     */
    window.pottsalatMisc = new PottsalatMisc();
    if (
        document.body.classList.contains("woocommerce-checkout") &&
        !document.body.classList.contains("woocommerce-order-received")
    ) {
        window.pottsalatCheckout = new LegacyCheckout();
    }

    /**
     * Header
     */
    if (document.getElementById("pottsalat-header")) {
        ReactDOM.render(
            <LazyWrapper>
                <Header />
            </LazyWrapper>,
            document.getElementById("pottsalat-header")
        );
    }

    /**
     * Home page
     */
    if (document.getElementById("front-page-react")) {
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <HomePage />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("front-page-react")
        );
    }
    /**
     * Franchise page
     */
    if (document.getElementById("franchise-landingpage-react")) {
        ReactDOM.render(
            <LazyWrapper>
                <FranchisePage />
            </LazyWrapper>,
            document.getElementById("franchise-landingpage-react")
        );
    }

    /**
     * Category page
     */
    if (document.getElementById("category-page-react")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CategoryPageApp />
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("category-page-react")
        );
    }

    /**
     * Footer
     */
    if (document.getElementById("footer-react")) {
        ReactDOM.render(
            <LazyWrapper>
                <NewFooter />
            </LazyWrapper>,
            document.getElementById("footer-react")
        );
    }

    /**
     * Checkout
     */
    if (document.getElementById("pottsalat-checkout")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <CheckoutApp config={reactConfig} />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("pottsalat-checkout")
        );
    }

    /**
     * Product details page
     */
    if (document.getElementById("pottsalat-product")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <ProductDetailsApp />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("pottsalat-product")
        );
    }

    /**
     * Customer area page
     */
    if (document.getElementById("pottsalat-customer-area")) {
        ReactDOM.render(
            <LazyWrapper>
                <CustomerAreaApp />
            </LazyWrapper>,
            document.getElementById("pottsalat-customer-area")
        );
    }

    /**
     * Recover Page
     */
    if (document.getElementById("pottsalat-reset-password")) {
        ReactDOM.render(
            <LazyWrapper>
                <ResetPasswordApp />
            </LazyWrapper>,
            document.getElementById("pottsalat-reset-password")
        );
    }

    /**
     * Order Confirmation page
     */
    if (document.getElementById("pottsalat-thank-you")) {

        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <ThankYouApp />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("pottsalat-thank-you")
        );
    }

    /**
     * Checkout delivery
     */
    if (document.getElementById("pottsalat-checkout-delivery")) {
        ReactDOM.render(
            <DeliverySelector
                ref={(deliverySelector) => {
                    window.deliverySelector = deliverySelector;
                }}
                config={reactConfig}
            />,
            document.getElementById("pottsalat-checkout-delivery")
        );
    }

    // /**
    //  * Delivery header info
    //  */
    // let delivery_header_root = document.getElementById("delivery-header-info");
    // if (delivery_header_root) {
    //     ReactDOM.render(
    //         <TopBar
    //             disableHeader={
    //                 delivery_header_root.getAttribute("data-hide-header") ===
    //                 "yes"
    //             }
    //         />,
    //         delivery_header_root
    //     );
    // }

    /**
     * Product addons
     */
    if (document.getElementById("pottsalat-product-addons")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <ProductAddons
                ref={(productAddons) => {
                    window.productAddons = productAddons;
                }}
                config={reactConfig}
            />,
            document.getElementById("pottsalat-product-addons")
        );
    }

    /**
     * Konfigurator
     */
    if (document.getElementById("pottsalat-mein-salat")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <KonfiguratorIngredientApp
                            productId={reactConfig.baseSaladId}
                            productType="salad"
                            config={reactConfig}
                        />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("pottsalat-mein-salat")
        );
    }
    if (document.getElementById("pottsalat-meine-ramen")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <KonfiguratorIngredientApp
                            productId={reactConfig.baseRamenId}
                            productType="ramen"
                            config={reactConfig}
                        />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("pottsalat-meine-ramen")
        );
    }
    if (document.getElementById("pottsalat-meine-bowl")) {
        let delivery_header_root = document.getElementById(
            "delivery-header-info"
        );
        if (delivery_header_root) {
            ReactDOM.render(
                <TopBar
                    disableHeader={
                        delivery_header_root.getAttribute(
                            "data-hide-header"
                        ) === "yes"
                    }
                />,
                delivery_header_root
            );
        }
        ReactDOM.render(
            <LazyWrapper>
                <TrackingContext>
                    <CartProvider>
                        <KonfiguratorIngredientApp
                            productId={reactConfig.baseBowlId}
                            productType="bowl"
                            config={reactConfig}
                        />
                    </CartProvider>
                </TrackingContext>
            </LazyWrapper>,
            document.getElementById("pottsalat-meine-bowl")
        );
    }
});
